import { EyeOffIcon } from './EyeOffIcon';

/**
 * author: Google
 * id 4D1385CF-1389-43D3-BD88-A83018434FB6
 * name eye-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-off.svg
 * tags
 */
export const VisibilityOffIcon = EyeOffIcon;
export default VisibilityOffIcon